module.exports = __webpack_public_path__ + "static/media/1426.5afd333e.png";